import type { Result } from '@orus.eu/result'

/**
 * Kanonik answers carry `orusHttpRequestId`, the id of the HTTP request that fetched them, and every call gets a new
 * one. It tells which call produced a value, not what the value is, so dimension comparisons leave it out: otherwise a
 * recompute that gets the same answer from Kanonik reads as a change to save, and cascades to every dependent dimension.
 */
export function omitOrusHttpRequestId(value: object): Record<string, unknown> {
  return Object.fromEntries(Object.entries(value).filter(([key]) => key !== 'orusHttpRequestId'))
}

export function omitResultOrusHttpRequestId(value: Result<object, object> | null | undefined): unknown {
  if (value == undefined) return value
  switch (value.type) {
    case 'success':
      return { type: 'success', output: omitOrusHttpRequestId(value.output) }
    case 'failure':
      return { type: 'failure', problem: omitOrusHttpRequestId(value.problem) }
  }
}
